class ReviewSrv {

	constructor ($resource, SERVICE_URL_CONSTANT, GlobalConfig) {
		const URL = SERVICE_URL_CONSTANT
		const modules = {}

		Object.keys(GlobalConfig.modules).forEach((key) => {
			modules[key] = key
		})

		// MAIN SERVICES
		var getReviewListData = $resource(URL.rosario + '/activity/:route', {}, {
			[modules.teaching]: {
				method: 'POST',
				params: {
					route: 'getActivitiesPlanning',
				},
			},
			[modules.academicManagement]: {
				method: 'POST',
				params: {
					route: 'getActivityPlanningAcademic',
				},
			},
			[modules.consolidation]: {
				method: 'POST',
				params: {
					route: 'getActivitiesTeachingStaff',
				},
			},
			[modules.investigation]: {
				method: 'POST',
				params: {
					route: 'getActivitiesResearch',
				},
			},
			[modules.extentionAndVisibility]: {
				method: 'POST',
				params: {
					route: 'getActivitiesExtension',
				},
			},
		})

		var getAutoevaluation = $resource(URL.rosario + '/asignature/:route', {}, {
			Autoevaluation: {
				method: 'GET',
				params: {
					route: 'getAutoevaluation',
				},
			},
		})

		var getReviewDetails = $resource(URL.rosario + '/activity/:route', {}, {
			[modules.teaching]: {
				method: 'POST',
				params: {
					route: 'getActivitiesDetail',
				},
			},
			[modules.academicManagement]: {
				method: 'POST',
				params: {
					route: 'getActivityDetailAcademic',
				},
			},
			[modules.consolidation]: {
				method: 'POST',
				params: {
					route: 'getActivityDetailTeachingStaff',
				},
			},
			[modules.investigation]: {
				method: 'POST',
				params: {
					route: 'getActivityDetailResearch',
				},
			},
			[modules.extentionAndVisibility]: {
				method: 'POST',
				params: {
					route: 'getActivityDetailExtension',
				},
			},
		})

		// GENERIC SERVICES
		var getTeacherWorkplans = $resource(URL.rosario + '/teacher/getAllWokplanByTeacher', {}, {
			request: {
				method: 'POST',
			},
		})

		var getAllWorkplanList = $resource(URL.rosario + '/reviewer/getAllWorkplanList', {}, {
			post: {
				method: 'POST',
			},
		})

		/* var setHands = $resource(URL.rosario + '/activity/:route', {}, {
      review: {
        method: 'POST',
        params: {
          route: 'setApprovedReviewed'
        }
      },
      approval: {
        method: 'POST',
        params: {
          route: 'setApprovedExecution'
        }
      },
      reviewExecution: {
        method: 'POST',
        params: {
          route: 'setReviewedExecution'
        }
      },
      evaluation: {
        method: 'POST',
        params: {
          route: 'setAcceptActivity'
        }
      },
    }) */

		var setReview = $resource(URL.rosario + '/activity/setApprovedReviewed', {}, {
			post: {
				method: 'POST',
			},
		})

		var setApprove = $resource(URL.rosario + '/activity/setApprovedExecution', {}, {
			post: {
				method: 'POST',
			},
		})

		var setAccept = $resource(URL.rosario + '/activity/setAcceptActivity', {}, {
			post: {
				method: 'POST',
			},
		})

		var setReviewedExecution = $resource(URL.rosario + '/activity/setReviewedExecution', {}, {
			post: {
				method: 'POST',
			},
		})

		var setStrategicTracing = $resource(URL.rosario + '/activity/setStrategicTracingActivity', {}, {
			post: {
				method: 'POST',
			},
		})

		var addActivityExecution = $resource(URL.rosario + '/activity/addActivityExecution', {}, {
			post: {
				method: 'POST',
			},
		})

		var setExecution = $resource(URL.rosario + '/activity/setExecution', {}, {
			post: {
				method: 'POST',
			},
		})

		var getExecutionEntries = $resource(URL.rosario + '/activity/getActivitiesEntries', {}, {
			post: {
				method: 'POST',
			},
		})

		var getDataFormActivityTeaching = $resource(URL.rosario + '/activity/getDataFormActivityTeaching', {}, {
			get: {
				method: 'GET',
			},
		})

		var editExecution = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/editExecution', {}, {
			post: {
				method: 'POST',
			},
		})

		var getSubmodulesByRole = $resource(SERVICE_URL_CONSTANT.rosario + '/role/getSubmodulesByRole', {}, {
			get: {
				method: 'POST',
			},
		})

		var getPendingActivitiesBySubmodule = $resource(URL.rosario + '/activity/getPendingActivitiesBySubmodule', {}, {
			post: {
				method: 'POST',
			},
		})

		// LIST PANEL SERVICES
		var getPanelWorkplans = $resource(URL.rosario + '/reviewer/getWorkplanByEvaluatorAndStage', {}, {
			post: {
				method: 'POST',
			},
		})

		var getWorkplanIndicators = $resource(URL.rosario + '/reviewer/getWorkplanIndicatorsByEvaluatorAndStage', {}, {
			post: {
				method: 'POST',
			},
		})

		var getWorkplanReviewIndicatorByEvaluatorAndIndicatorType = $resource(URL.rosario + '/reviewer/getWorkplanReviewIndicatorByEvaluatorAndIndicatorType', {}, {
			post: {
				method: 'POST',
			},
		})

		var getFinishedWorkplanIndicator = $resource(URL.rosario + '/reviewer/getFinishedWorkplanIndicatorByEvaluatorAndStage', {}, {
			post: {
				method: 'POST',
			},
		})

		//EVALUATION
		var getWorkplanForEvaluationByIndicator = $resource(URL.rosario + '/reviewer/getWorkplanForEvaluationByIndicator', {}, {
			post: {
				method: 'POST',
			},
		})
		var getIndicatorsForWorkplanEvaluationByIndicator = $resource(URL.rosario + '/reviewer/getIndicatorsForWorkplanEvaluationByIndicator', {}, {
			post: {
				method: 'POST',
			},
		})

		// TEACHING SERVICES
		var getReviewData = $resource(URL.rosario + '/activity/getActivitiesPlanning', {}, {
			request: {
				method: 'POST',
			},
		})

		var getActivityDetails = $resource(URL.rosario + '/activity/getActivitiesDetail', {}, {
			request: {
				method: 'POST',
			},
		})

		// ACADEMIC MANAGEMENT SERVICES
		var getAcademicManagmentData = $resource(URL.rosario + '/activity/getActivityPlanningAcademic', {}, {
			request: {
				method: 'POST',
			},
		})

		var getAcademicManagmentActivityDetails = $resource(URL.rosario + '/activity/getActivityDetailAcademic', {}, {
			request: {
				method: 'POST',
			},
		})

		var setactivityTag = $resource(URL.rosario + '/activity/setactivityTag', {}, {
			set: {
				method: 'POST',
			},
		})

		var getWorkPlanGeneralDetail = $resource(URL.rosario + '/general/getWorkPlanGeneralDetail', {}, {
			get: {
				method: 'POST',
			},
		})

		var getActivitiesNotExecutionByTeacher = $resource(URL.rosario + '/teacher/getActivitiesNotExecutionByTeacher', {}, {
			get: {
				method: 'POST',
			},
		})

		var getActNotExecutionByTeacher = $resource(URL.rosario + '/teacher/getActNotExecutionByTeacher', {}, {
			get: {
				method: 'POST',
			},
		})

		var getTeachershistoricalWorkplan = $resource(URL.rosario + '/general/getTeachershistoricalWorkplan', {}, {
			get: {
				method: 'GET',
			},
		})

		// INVESTIGATION SERVICES

		var addCustomActivity = $resource(SERVICE_URL_CONSTANT.rosario + '/activity/:route', {}, {
			product: {
				method: 'POST',
				params: {
					route: 'addActivityProduct',
				},
			},
			project: {
				method: 'POST',
				params: {
					route: 'addActivityProject',
				},
			},
			extensionProject: {
				method: 'POST',
				params: {
					route: 'addActivityProjectExtension',
				},
			},
			updateAssignaturestatus: {
				method: 'POST',
				params: {
					route: 'updateAssignaturestatus',
				},
			},
		})

		var getReflectionMethod = $resource(URL.rosario + '/asignature/getReflection', {}, {
			get: {
				method: 'GET',
			},
		})

		var getGraphSelectionListMethod = $resource(URL.rosario + '/asignature/getGraphSelectionList', {}, {
			get: {
				method: 'GET',
			},
		})

		// SERVICES INJECTION
		return {
			getReviewListData                                    : getReviewListData,
			getReviewDetails                                     : getReviewDetails,
			// GENERIC
			getTeacherWorkplans                                  : getTeacherWorkplans,
			getAllWorkplanList                                   : getAllWorkplanList,
			setReview                                            : setReview,
			setApprove                                           : setApprove,
			setAccept                                            : setAccept,
			setExecution                                         : setExecution,
			setReviewedExecution                                 : setReviewedExecution,
			setStrategicTracing                                  : setStrategicTracing,
			editExecution                                        : editExecution,
			getActivitiesNotExecutionByTeacher                   : getActivitiesNotExecutionByTeacher,
			getActNotExecutionByTeacher                          : getActNotExecutionByTeacher,
			// MODALS
			addActivityExecution                                 : addActivityExecution,
			getExecutionEntries                                  : getExecutionEntries,
			getDataFormActivityTeaching                          : getDataFormActivityTeaching,
			// LIST PANEL
			getPanelWorkplans                                    : getPanelWorkplans,
			// INDICATORS PANEL
			getWorkplanIndicators                                : getWorkplanIndicators,
			getFinishedWorkplanIndicator                         : getFinishedWorkplanIndicator,
			getWorkplanReviewIndicatorByEvaluatorAndIndicatorType: getWorkplanReviewIndicatorByEvaluatorAndIndicatorType,
			// EVALUATION
			getWorkplanForEvaluationByIndicator                  : getWorkplanForEvaluationByIndicator,
			getIndicatorsForWorkplanEvaluationByIndicator        : getIndicatorsForWorkplanEvaluationByIndicator,
			// TEACHING
			getReviewData                                        : getReviewData,
			getActivityDetails                                   : getActivityDetails,
			// ACADEMIC MANAGEMENT
			getAcademicManagmentData                             : getAcademicManagmentData,
			getAcademicManagmentActivityDetails                  : getAcademicManagmentActivityDetails,
			setactivityTag                                       : setactivityTag,
			getWorkPlanGeneralDetail                             : getWorkPlanGeneralDetail,
			// INVESTIGATION
			addCustomActivity                                    : addCustomActivity,
			getSubmodulesByRole                                  : getSubmodulesByRole,
			getPendingActivitiesBySubmodule                      : getPendingActivitiesBySubmodule,
			//AUTOEVALUACION INTEGRAL
			getAutoevaluation                                    : getAutoevaluation,
			getReflectionMethod                                  : getReflectionMethod,
			getGraphSelectionListMethod                          : getGraphSelectionListMethod,
			getTeachershistoricalWorkplan                        : getTeachershistoricalWorkplan,
		}
	}

}
ReviewSrv.$inject = [ '$resource', 'SERVICE_URL_CONSTANT', 'GlobalConfig' ]
export default angular.module('services.ReviewSrv', []).service('ReviewSrv', ReviewSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/reviewSrv.js